import { F as d, b as E, a as u, c as I, g as O } from "./chunks/index-69148435.mjs";
import { e as m, c as F, d as h, a as w, b as g, T as P, i as V, h as U, s as f, f as k, j as p, g as L } from "./chunks/toast-c61fd8a5.mjs";
import i from "vue";
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const l = (o, e, a = () => {
}) => {
  const s = document.createElement("div");
  (document.querySelector(e == null ? void 0 : e.container) || document.body).appendChild(s);
  const r = new i({
    el: s,
    name: "VueDialogHelper",
    render: (n) => n(o, {
      props: e,
      on: {
        close: (...T) => {
          a(T), r.$destroy();
        }
      }
    })
  });
};
export {
  d as FilePicker,
  E as FilePickerBuilder,
  u as FilePickerType,
  I as FilePickerVue,
  m as TOAST_ARIA_LIVE_ASSERTIVE,
  F as TOAST_ARIA_LIVE_OFF,
  h as TOAST_ARIA_LIVE_POLITE,
  w as TOAST_DEFAULT_TIMEOUT,
  g as TOAST_PERMANENT_TIMEOUT,
  P as TOAST_UNDO_TIMEOUT,
  O as getFilePickerBuilder,
  V as showError,
  U as showInfo,
  f as showMessage,
  k as showSuccess,
  p as showUndo,
  L as showWarning,
  l as spawnDialog
};
